import { PendingScheduleType } from '../common/types/calendar'
import { PENDING_SCHEDULES_COLOR } from '../constants/calendar/pendingSchedule'

export type Row = {
  process_id: string
  process_name: string
  estimated_time: number
}

function isEmpty(obj:Row[]){
  return !Object.keys(obj).length;
}

export const convertPendingSchedules = (rows: Row[]): PendingScheduleType[] => {
  if(isEmpty(rows)){
    rows = [];
  }
  return rows.map((row: Row) => {
    return {
      color: PENDING_SCHEDULES_COLOR,
      estimated_time: row.estimated_time,
      id: row.process_id,
      name: row.process_name,
    }
  })
}
